import * as React from 'react';
import {ViewStyle} from 'react-native';

interface IProps {
  width?: number;
  style?: ViewStyle;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1"
        y="1"
        width="11"
        height="14"
        fill="#E9F4FF"
        stroke="#0088FF"
        stroke-width="2"
      />
      <rect
        x="8"
        y="8"
        width="11"
        height="14"
        fill="#E9F4FF"
        stroke="#0088FF"
        stroke-width="2"
      />
    </svg>
  );
};
